const UserProfile = () => {
  return (
    <div className="flex grow flex-col items-center justify-center text-center text-gray-800">
      <h1 className=" text-7xl font-extrabold">User Profile</h1>
      <p className="text-3xl">Page is under development </p>
    </div>
  );
};

export default UserProfile;
